import React, { Component } from 'react'

import Navigation from './Navigation'

import adminStyles from './styles/admin.scss'

export default class LoggedIn extends Component {
  render() {
    const { currentAccount, currentOrganisation, onLogout } = this.props

    return (
      <div>
        <div className={adminStyles.app}>
          <Navigation
            currentAccount={currentAccount}
            currentOrganisation={currentOrganisation}
            onLogout={onLogout}
          />

          <div>{this.props.children}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LoggedIn.js